module.exports = __webpack_public_path__ + "img/iaccount.24903685.svg";